import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import { Row, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';
import { PerformanceHeader } from '@/modules/wealth/components/PerformanceHeader';
import { PerformanceChart } from '@/modules/wealth/components/PerformanceChart';

import {
  getPortfolioChart,
  PortfolioChartAxisX,
  PortfolioChartAxisY,
  PortfolioChartFilter,
  PortfolioChartParams,
  PortfolioChartSummary
} from '@/modules/wealth/services/portfolio';

import { getFilterOptions } from '@/modules/wealth/views/IndexPortfolio/helpers';

interface Props {
  portfolioId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Performance',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
};



const router = useRouter();

const isLoading = ref(true);
const hasError = ref(false);
const periodFilters = ref<PortfolioChartFilter[]>([]);
const benchmarkFilters = ref<PortfolioChartFilter[]>([]);
const portfolioChartSummary = ref<PortfolioChartSummary | null>(null);
const chartAxisX = ref<PortfolioChartAxisX[]>([]);
const chartAxisY = ref<PortfolioChartAxisY[]>([]);
const updatedAt = ref<string | null>(null);
const isChartAnimationInProgress = ref(false);

const portfolioParams = computed<PortfolioChartParams>(() => {
  return {
    portfolioId: props.portfolioId,
    periodFilter: getActiveFilter(periodFilters.value),
    benchmark: getActiveFilter(benchmarkFilters.value)
  };
});

const isHeaderLoading = computed(() => {
  return isLoading.value || isChartAnimationInProgress.value;
});

const isChartLoading = computed(() => {
  return (
    isLoading.value &&
    chartAxisX.value.length === 0 &&
    chartAxisY.value.length === 0
  );
});

async function fetchPortfolioChart() {
  isLoading.value = true;
  hasError.value = false;

  try {
    const portfolioChart = await getPortfolioChart(portfolioParams.value);

    periodFilters.value = getFilterOptions(portfolioChart.periodFilters);
    benchmarkFilters.value = getFilterOptions(portfolioChart.benchmarks);
    portfolioChartSummary.value = portfolioChart.summary;
    chartAxisX.value = portfolioChart.axisX;
    chartAxisY.value = portfolioChart.axisY;
    updatedAt.value = portfolioChart.updatedAt.formatted;
  } catch (error) {
    hasError.value = true;
    isChartAnimationInProgress.value = false;
  } finally {
    isLoading.value = false;
  }
}

function handleOnAnimationStateChange(isAnimationInProgress: boolean) {
  isChartAnimationInProgress.value = isAnimationInProgress;
}

function getActiveFilter(filters: PortfolioChartFilter[] | null) {
  if (!filters) {
    return '';
  }

  return filters.find(filter => filter.active)?.key;
}

async function handleBenchmarkFilterChange(value: string) {
  benchmarkFilters.value = benchmarkFilters.value.map(filter => ({
    ...filter,
    active: filter.value === value
  }));

  await fetchPortfolioChart();
}

async function handlePeriodFilterChange(value: string) {
  periodFilters.value = periodFilters.value.map(filter => ({
    ...filter,
    active: filter.value === value
  }));

  await fetchPortfolioChart();
}

function goToPerformanceHistory() {
  router.push({
    name: 'wealthPerformance',
    query: { portfolio: props.portfolioId }
  });
}

onMounted(async () => {
  await fetchPortfolioChart();
});

return { __sfc: true,props, router, isLoading, hasError, periodFilters, benchmarkFilters, portfolioChartSummary, chartAxisX, chartAxisY, updatedAt, isChartAnimationInProgress, portfolioParams, isHeaderLoading, isChartLoading, fetchPortfolioChart, handleOnAnimationStateChange, getActiveFilter, handleBenchmarkFilterChange, handlePeriodFilterChange, goToPerformanceHistory, Row, InitialAvatarIcon, PerformanceHeader, PerformanceChart }
}

})